const hasValue = (value: unknown): boolean => {
  return typeof value !== 'undefined' && value !== null && value !== '';
};

export default hasValue;
